import Auth0Identity from './identity';

/**
 * Clears all identity related session/local storage items.
 * Returns void when successful, throws an error otherwise.
 *
 **/
export function clearSession(): void {
  try {
    Auth0Identity.userIdentity = {};
  } catch (e) {
    throw new Error('Error clearing session.');
  }
}

export default clearSession;
